export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'b729f129-e7e4-4693-9ce0-0572035932d7';
export const MODAL_CLOSE_SEC = 2.5;
